/** 地形の問い合わせ（docs/03_simulation.md 2 章） */
import {
  aspectAt,
  gradientAt,
  sampleBilinear,
  sampleNearest,
  slopeDegAt,
  type GridSpec,
} from '../../core/grid';
import type { Biome, WorldData } from '../../core/world';

export interface TerrainSampler {
  heightAt(x: number, z: number): number;
  /** 高さの勾配（dh/dx, dh/dz） */
  gradientAt(x: number, z: number): { gx: number; gz: number };
  slopeDegAt(x: number, z: number): number;
  /** 斜面の下り方向の方位（北 0、時計回り、ラジアン） */
  aspectAt(x: number, z: number): number;
  biomeAt(x: number, z: number): Biome;
}

export function createTerrainSampler(
  world: Pick<WorldData, 'nx' | 'nz' | 'cellM' | 'height' | 'biome'>,
): TerrainSampler {
  const spec: GridSpec = { nx: world.nx, nz: world.nz, cellM: world.cellM };
  return {
    heightAt: (x, z) => sampleBilinear(spec, world.height, x, z),
    gradientAt: (x, z) => gradientAt(spec, world.height, x, z),
    slopeDegAt: (x, z) => slopeDegAt(spec, world.height, x, z),
    aspectAt: (x, z) => aspectAt(spec, world.height, x, z),
    biomeAt: (x, z) => sampleNearest(spec, world.biome, x, z) as Biome,
  };
}
